export default __webpack_public_path__ + "static/media/serviciiHero.8b89c30d.jpg";